export enum UIRole {
  ARCHITECT = 'architect',
  OPERATOR = 'operator',
  COACH = 'coach',
  INTEGRATOR = 'integrator',
  DEVELOPMENT = 'development',
  MARKETFIT = 'marketfit',
}

export const UI_ROLE_LABELS: Record<UIRole, string> = {
  [UIRole.ARCHITECT]: 'Architect',
  [UIRole.OPERATOR]: 'Operator',
  [UIRole.COACH]: 'Coach',
  [UIRole.INTEGRATOR]: 'Integrator',
  [UIRole.DEVELOPMENT]: 'Development',
  [UIRole.MARKETFIT]: 'MarketFit',
};

export const UI_ROLE_OPTIONS = Object.values(UIRole).map(role => ({
  value: role,
  label: UI_ROLE_LABELS[role],
}));
